/**
 * Faceted Search - Async - Show results button
 */

(() => {
    let form = document.querySelector('.js-faceted-search-form');
    let show_results_button = document.querySelector('.js-show-results-button');
    let wait_button = document.querySelector('.js-faceted-search-wait-button');

    if (!form || !show_results_button || !wait_button) {
        return;
    }

    function getResults() {
        return form.querySelector('.js-faceted-search-results');
    }

    function updateButtonLabel() {
        let label = show_results_button.querySelector(
            '.js-show-results-button-label'
        );

        if (!label) {
            return;
        }

        const results = getResults();

        if (!results) {
            return;
        }

        label.innerHTML =
            show_results_button.getAttribute('data-label') +
            ' (' +
            results.getAttribute('data-posts-total') +
            ')';
    }

    function enableButton() {
        show_results_button.disabled = false;
        show_results_button.classList.remove('-loading');
        show_results_button.removeAttribute('aria-description');
    }

    function disableButton() {
        show_results_button.disabled = true;
        show_results_button.classList.add('-loading');
        show_results_button.setAttribute(
            'aria-description',
            show_results_button.getAttribute('data-loading')
        );
    }

    function focusResults() {
        // console.log('Focusing results...');

        if (window.faceted_search_request_active) {
            return;
        }

        const results = getResults();

        if (!results) {
            return;
        }

        const link = results.querySelector('.js-link-collection-link');

        if (link) {
            link.classList.add('js-backwards-focus-ignore');
            link.focus();
            link.classList.remove('js-backwards-focus-ignore');
        } else {
            location.hash = '#search-results';
        }

        wait_button.classList.remove('-visible');
        window.faceted_search_focus_results_on_settle = false;
    }

    function focusWaitButton() {
        wait_button.classList.add('-visible');
        wait_button.focus();
    }

    function scrollToResults(e) {
        // console.log('Scrolling to results...');
        window.sticky_header_tools?.scrollTo(getResults());
    }

    function showResults(e) {
        if (window.faceted_search_request_active) {
            focusWaitButton();
            scrollToResults();
            window.faceted_search_focus_results_on_settle = true;
        } else {
            scrollToResults();
            focusResults();
        }
    }

    function onSubmit(e) {
        e.preventDefault();
        showResults();
    }

    function checkFocus() {
        // console.log('Checking focus...');

        if (
            document.activeElement.classList.contains('js-link-collection-link')
        ) {
            focusWaitButton();
            window.faceted_search_focus_results_on_settle = true;
        }
    }

    function updateLiveRegion() {
        let live_region = form.querySelector('.js-faceted-search-live-region');

        if (!live_region) {
            return;
        }

        const results = form.querySelector('.js-faceted-search-results-amount');

        if (!results) {
            return;
        }

        live_region.innerHTML = results.innerHTML;
    }

    window.faceted_search_request_active = 0;
    window.faceted_search_focus_results_on_settle = false;
    form.addEventListener('submit', onSubmit);
    form.addEventListener('htmx:beforeRequest', (e) => {
        window.faceted_search_request_active++;
        disableButton();
        checkFocus();
    });
    form.addEventListener('htmx:afterOnLoad', (e) => {
        window.faceted_search_request_active--;
        enableButton();
    });
    form.addEventListener('htmx:afterSettle', (e) => {
        updateButtonLabel();
        updateLiveRegion();

        if (window.faceted_search_focus_results_on_settle) {
            focusResults();
        }
    });
    show_results_button.addEventListener('click', showResults);

    updateButtonLabel();
})();
